var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "detail-container",
    },
    [
      _c("div", { staticClass: "btn-row" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-button",
              { staticClass: "wl-green", on: { click: _vm.onCloseClick } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("login_btn_back")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right", attrs: { id: "right-container" } },
          [
            _vm.getUser.userType == "1"
              ? _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    on: { click: _vm.onNotifyClientClick },
                  },
                  [
                    _c("img", { attrs: { src: _vm.exportIcon } }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("ita_btn_notify_client")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm.getUser.userType == "1"
              ? _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    on: { click: _vm.onArchiveQuestionnaireClick },
                  },
                  [
                    _c("img", { attrs: { src: _vm.exportIcon } }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("ita_btn_archive_questionnaire")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          class: [
            "tab-row",
            _vm.getUser.userType == "2" ? "tab-row-client" : "",
          ],
        },
        [
          _c("div", { staticClass: "tab-arrows tab-arrows-left" }, [
            _c("i", {
              class: [
                "tab-arrow",
                "arrow-left",
                "el-icon-caret-left",
                _vm.entityLeftDisable ? "disabled" : "",
              ],
              on: { click: _vm.entityLeft },
            }),
            _c("div", { staticClass: "丨" }),
            _c("i", {
              class: [
                "tab-arrow",
                "arrow-right",
                "el-icon-caret-right",
                _vm.entityRightDisable ? "disabled" : "",
              ],
              on: { click: _vm.entityRight },
            }),
          ]),
          _vm._l(_vm.displayEntities, function (v, k) {
            return _c(
              "div",
              {
                key: k,
                class: [
                  "tab-entity",
                  v.id == _vm.currentEntity ? "tab-entity-active" : "",
                ],
                style: { visibility: v.id == -1 ? "hidden" : "" },
                on: {
                  click: function ($event) {
                    return _vm.switchEntity(v)
                  },
                },
              },
              [_vm._v("\n            " + _vm._s(v.entityName) + "\n        ")]
            )
          }),
          _c("div", { staticClass: "tab-arrows tab-arrows-right" }, [
            _c("i", {
              class: [
                "tab-arrow",
                "arrow-left",
                "el-icon-caret-left",
                _vm.entityLeftDisable ? "disabled" : "",
              ],
              on: { click: _vm.entityLeft },
            }),
            _c("div", { staticClass: "丨" }),
            _c("i", {
              class: [
                "tab-arrow",
                "arrow-right",
                "el-icon-caret-right",
                _vm.entityRightDisable ? "disabled" : "",
              ],
              on: { click: _vm.entityRight },
            }),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "body" }, [
        _c(
          "div",
          { staticClass: "left" },
          _vm._l(_vm.displaySectionList, function (v, k) {
            return _c(
              "div",
              {
                key: k,
                class: [
                  "section-item",
                  v.id == _vm.currentSection ? "section-item-active" : "",
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "title",
                    on: {
                      click: function ($event) {
                        return _vm.switchSection(v)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "icon",
                      attrs: { src: _vm.statusIcon[`_${v.status}`] },
                    }),
                    _c("div", { staticClass: "text" }, [
                      _vm._v(_vm._s(v.sectionI18n)),
                    ]),
                  ]
                ),
                _c(
                  "el-popover",
                  { attrs: { placement: "bottom-start", trigger: "click" } },
                  [
                    _c("i", {
                      staticClass: "el-icon-more",
                      attrs: { slot: "reference" },
                      slot: "reference",
                    }),
                    _c("div", { staticClass: "section-popover" }, [
                      _vm.getUser.userType == "1"
                        ? _c(
                            "div",
                            { staticClass: "section-popover-row" },
                            [
                              _c(
                                "div",
                                { staticClass: "section-popover-title" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ita_table_header_status"))
                                  ),
                                ]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticClass: "section-popover-select",
                                  on: {
                                    change: function ($event) {
                                      return _vm.onSectionPopoverHide(v)
                                    },
                                  },
                                  model: {
                                    value: v.status,
                                    callback: function ($$v) {
                                      _vm.$set(v, "status", $$v)
                                    },
                                    expression: "v.status",
                                  },
                                },
                                _vm._l(_vm.statusOptions, function (vv, kk) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: kk,
                                      staticClass: "section-popover-option",
                                      attrs: {
                                        value: vv.value,
                                        label: _vm.$t(vv.label),
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "section-popover-option-img",
                                        attrs: { src: vv.icon },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "section-popover-option-text",
                                        },
                                        [_vm._v(_vm._s(_vm.$t(vv.label)))]
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "section-popover-row" },
                        [
                          _c("div", { staticClass: "section-popover-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("ita_table_header_client_responsible")
                              )
                            ),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticClass: "section-popover-select",
                              on: {
                                change: function ($event) {
                                  return _vm.onSectionPopoverHide(v)
                                },
                              },
                              model: {
                                value: v.clientResponsible,
                                callback: function ($$v) {
                                  _vm.$set(v, "clientResponsible", $$v)
                                },
                                expression: "v.clientResponsible",
                              },
                            },
                            _vm._l(_vm.clientOwnerList, function (vv, kk) {
                              return _c(
                                "el-option",
                                {
                                  key: kk,
                                  staticClass: "section-popover-option",
                                  attrs: {
                                    value: vv.userId,
                                    label: vv.userName,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "section-popover-option-text",
                                    },
                                    [_vm._v(_vm._s(vv.userName))]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.getUser.userType == "1"
                        ? _c(
                            "div",
                            { staticClass: "section-popover-row" },
                            [
                              _c(
                                "div",
                                { staticClass: "section-popover-title" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("ita_table_header_period_date")
                                    )
                                  ),
                                ]
                              ),
                              _c("el-date-picker", {
                                ref: "datepicker",
                                refInFor: true,
                                staticClass:
                                  "wl-item wl-date-item input-with-select",
                                attrs: {
                                  type: "date",
                                  "range-separator": _vm.$t("SITE_TO"),
                                  "start-placeholder": _vm.$t("create_date"),
                                  "end-placeholder": _vm.$t("create_date"),
                                  "value-format": "yyyy-MM-dd",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onSectionPopoverHide(v)
                                  },
                                },
                                model: {
                                  value: v.periodEndDate,
                                  callback: function ($$v) {
                                    _vm.$set(v, "periodEndDate", $$v)
                                  },
                                  expression: "v.periodEndDate",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.getUser.userType == "1"
                        ? _c(
                            "div",
                            { staticClass: "section-popover-row" },
                            [
                              _c(
                                "div",
                                { staticClass: "section-popover-title" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ita_table_header_due_date"))
                                  ),
                                ]
                              ),
                              _c("el-date-picker", {
                                ref: "datepicker",
                                refInFor: true,
                                staticClass:
                                  "wl-item wl-date-item input-with-select",
                                attrs: {
                                  type: "date",
                                  "range-separator": _vm.$t("SITE_TO"),
                                  "start-placeholder": _vm.$t("create_date"),
                                  "end-placeholder": _vm.$t("create_date"),
                                  "value-format": "yyyy-MM-dd",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onSectionPopoverHide(v)
                                  },
                                },
                                model: {
                                  value: v.dueDate,
                                  callback: function ($$v) {
                                    _vm.$set(v, "dueDate", $$v)
                                  },
                                  expression: "v.dueDate",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "right" },
          [
            _vm._l(_vm.displayDetailList, function (v, k) {
              return _c(
                "div",
                {
                  key: k,
                  class: [
                    "question-item",
                    v.id == _vm.hightlightQuestionId
                      ? "question-item-highlight"
                      : "",
                  ],
                  attrs: { id: `question_${v.id}` },
                },
                [
                  _c(
                    "TitleRow",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: v.display,
                          expression: "v.display",
                        },
                      ],
                      staticClass: "title-row",
                      attrs: {
                        titleText: `${v.seq}.${v.titleI18n}`,
                        subtitleText: v.subTitleI18n,
                        showIcon: v.seq && v.seq.indexOf(".") == -1,
                      },
                    },
                    [
                      _c("commentPopover", {
                        attrs: {
                          slot: "comment",
                          messageList: v.messageList,
                          summaryId: _vm.currentSummaryId,
                          questionId: v.id,
                        },
                        slot: "comment",
                      }),
                    ],
                    1
                  ),
                  v.type == "Radio" && v.display
                    ? [
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "radiogroup",
                            on: { input: (e) => _vm.radioChange(k, e) },
                            model: {
                              value: v.answer,
                              callback: function ($$v) {
                                _vm.$set(v, "answer", $$v)
                              },
                              expression: "v.answer",
                            },
                          },
                          _vm._l(v.optionsI18n, function (vv, kk) {
                            return _c(
                              "el-radio",
                              {
                                key: kk,
                                attrs: {
                                  label: `${kk - 0 + 1}`,
                                  disabled: _vm.disableEdit,
                                },
                              },
                              [_vm._v(_vm._s(vv))]
                            )
                          }),
                          1
                        ),
                      ]
                    : _vm._e(),
                  v.type == "Upload" && v.display
                    ? [
                        _c("UploadFile", {
                          staticClass: "uploadfile",
                          attrs: {
                            currentSummaryId: _vm.currentSummaryId,
                            value: v.fileList,
                            disableEdit: _vm.disableEdit,
                            onChange: (e) => _vm.onUploadChange(k, e),
                          },
                        }),
                      ]
                    : _vm._e(),
                  v.type == "Long_Text" && v.display
                    ? [
                        _c("richtextInput", {
                          staticClass: "richinput",
                          attrs: {
                            disableEdit: _vm.disableEdit,
                            onChange: (e) => _vm.onRichTextChange(k, e),
                            value: v.answer,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(v, "answer", $event)
                            },
                          },
                        }),
                      ]
                    : _vm._e(),
                  v.type == "Short_Text" && v.display
                    ? [
                        _c("el-input", {
                          staticClass: "shortTextInput",
                          attrs: {
                            disabled: _vm.disableEdit,
                            maxlength: 500,
                            "show-word-limit": "",
                          },
                          on: { input: (e) => _vm.onShortTextInput(k, e) },
                          model: {
                            value: v.answer,
                            callback: function ($$v) {
                              _vm.$set(v, "answer", $$v)
                            },
                            expression: "v.answer",
                          },
                        }),
                      ]
                    : _vm._e(),
                  v.type == "Table" && v.display
                    ? [
                        _c("freeTable", {
                          staticClass: "freetable",
                          attrs: {
                            disableEdit: _vm.disableEdit,
                            columns: v.columnsI18n,
                            value: v.answer,
                            onChange: (e) => _vm.onFreeTableChange(k, e),
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
            _c("el-divider", { staticClass: "divider" }),
            !_vm.disableEdit
              ? _c(
                  "div",
                  { staticClass: "btns" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn cancel-btn",
                        on: { click: _vm.onCloseClick },
                      },
                      [_vm._v(_vm._s(_vm.$t("btn_close")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn wl-green",
                        on: { click: _vm.onSaveClick },
                      },
                      [_vm._v(_vm._s(_vm.$t("btn_save")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn wl-green",
                        attrs: { disabled: _vm.disableEdit },
                        on: { click: _vm.onSubmitClick },
                      },
                      [_vm._v(_vm._s(_vm.$t("btn_submit")))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c("noticeUndone", {
        attrs: {
          show: _vm.showNoticeUndone,
          summaryList: _vm.noticeUndoneSummaryList,
        },
        on: {
          "update:show": function ($event) {
            _vm.showNoticeUndone = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }